<template>
<div class="page-body">
  <div ui-view="" class="app-body" id="view" style="padding-bottom:0">
    <page-header title="개인정보처리방침" description="개인정보처리방침 문서를 보여줍니다.">
    </page-header>
    <div class="page-body pt-30 ph-30" style="display:flex; flex-direction:column">

      <div class="box-header" style="display:flex;flex-direction:row;justify-content: space-between;">
        <div>이전글 : <a style="cursor: pointer;" @click="clickItem(prevItem)" v-if="prevItem">{{prevItem.title}}</a></div>
        <div>다음글 : <a style="cursor: pointer;" @click="clickItem(nextItem)" v-if="nextItem">{{nextItem.title}}</a></div>
      </div>
      <div class="box mt-20" style="display:flex; flex-direction: column; flex:1">
        <div class="box-header" style="display:flex;flex-direction:row">
          <div style="flex:1">
            <h3>{{item.title}}</h3>
          </div>
          <div>{{item.createUser}} {{getDate(item.modifiedDate)}}</div>
        </div>
        <div class="box-body" style="display:flex; flex-direction: column; flex:1;padding-bottom: 0;">
           <div class="box border-box mb-10" v-for="(file, index) in item.fileList" :key="index" style="display:flex; flex-direction: column; flex:1">
            <div class="box-body">
              <button class="btn btn-m flat pull-right" style="margin:-3px -3px 0 0" @click="fileDownload(file)">
                <i class="icon-download"></i>
              </button>
              <i class="icon-image"></i>
              <span class="mh-5">{{file.fileName}}</span>
              <h5 class="d-inline-block">{{file.fileSize}}kb</h5>/
            </div>
            <div style="display:flex; flex-direction: column; flex:1">
              <div v-if="file.extension.toLowerCase() == 'pdf'" style="display:flex; flex-direction: column; flex:1">
                <div data-v-49732d56="" class="pdf pdfobject-container" style="overflow: hidden; display:flex; flex-direction: column; flex:1">
                  <embed class="pdfobject" allowscriptaccess="always"  :src="'/api/public/board/openPdf/' +file.saveName+ '#navpanes=0&toolbar=0&statusbar=0&view=FitH'" type="application/pdf" style="overflow: auto; width: 100%; height: 100%; flex:1"></div>
              </div>
            </div>
          </div>
          <form action="">
            <div class="form-group row">
              <div class="col-12" id="smart_editor2">
                <div class="se2_outputarea" v-html="item.content"></div>
              </div>
            </div>
          </form>

        </div>
      </div>
      <!--div class="btn-wrap mt-30" style="justify-content: space-between;">
        <div>이전글 : {{prevNextItem.prev.title}}</div>
        <div>다음글 : {{prevNextItem.prev.title}}</div>
      </div-->
    </div>
  </div>
</div>
</template>

<script>
import PageHeader from '@/layout/PageHeader.vue'
import DataTableBase from '@/components/common/dataTableBase';
export default {
  mixins: [DataTableBase],
  props: ['boardTitle', 'boardName'],
  components: {
    PageHeader,


  },
  data(){
    return {
      getApi: 'board/privacyPolicy',
      data: {title: '공지사항', userName: '강선호', content: '동해물과 백두신이 마르고'},
      prevItem: {title: '111'}, 
      nextItem: {title: 'null'},
    }
  },
  mounted(){
    this.init();
    var that = this;
  },
  computed: {
    getDate(){
      return (date) =>{
        return moment(date).format(this.dateFormat);
      }
    },
    getPrevNext() {
      return () => {
        return this.prevNextItem;
      }
    }
  },
  methods: {
    init(){

      this.item = {title: ''};
      this.prevItem = {title: ''};
      this.nextItem = {title: ''};
      var id = null;
        if(this.$route.params.id)
          id = this.$route.params.id;
      this.getItemById(id);
    },
    getItemById(id){
      var that = this;
      this.$http.get('/api/private/' + this.getApi + '/' + id + '/prevNext')
        .then((result) => {
          that.prevItem = result.data.prev;
          that.nextItem = result.data.next;
          this.item = result.data.current;
        }).catch((e) =>{
          console.log(e);
      })
    },
    clickItem(item){
      var query = Object.assign({},this.$route.query);
      query.mode = 'view';
      this.$router.push({ path: '/app/infou/' + item.boardIndex, query: query, props: {item: item}});
      setTimeout(function(){
        this.init();
      }.bind(this),1000)
    },
    fileDownload(file){
        debugger;

        this.$http.get('/api/public/board/download/'+file.saveName, {responseType: 'blob'},)
          .then(function(result) {
            const url = window.URL.createObjectURL(new Blob([result.data], {type: 'application/octet-stream'}));
            const link = document.createElement('a');
            link.href = url;

            debugger;
            let fileName = file.fileName;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
          }.bind(this)).catch((e) =>{
            debugger;
            this.noti("다운로드 실패", "해당 파일을 찾을 수 없습니다.", 'warning');
          })
    },
    edit(){
      var query = Object.assign({},this.$route.query);
      //var query = {};
      query.mode = 'edit';
      this.$router.push({ path: '/app/' + this.boardName + '/'+ this.item.boardIndex, query:query})
    },
    list(){
      var query = Object.assign({},this.$route.query);
      query.mode = 'list';
      this.$router.push({ path: '/app/'+ this.boardName +'/', query: query})
    }
  }
}
</script>

<style>
ol {
    display: block;
    list-style-type: decimal;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 40px;
}
</style>
